import Logo from '../Logo'
import InfoUsuario from '../InfoUsuario';
import Filtros from '../Filtros';
import FiltrosPainelBordo from '../FiltrosPainelBordo';
import backImagem from '../../assets/img/back.svg'
import { useNavigate } from "react-router-dom";
import { logout, verifyAdmin } from "../../auth";
import "./Header.css";
import { useEffect, useState } from 'react';
import mmlogo from '../../assets/img/mmlogo.svg'


function Header({ type, onFiltrarClick, dadosCarregados, cargoChange, mesAnoChange }) {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false)


  useEffect(() => {
    const isAdminVerified = verifyAdmin()
    setIsAdmin(isAdminVerified)
  }, [isAdmin])

  function handleLogout() {
    logout();
    navigate("/login");
  }

  function handleAdmin() {
    navigate('/admin');
  }

  function voltar() {
    localStorage.setItem('carregarFiltrosTemporarios', true);
    navigate('/');

  }

  // Conteúdo do Logo para ambos os layouts
  const logoContent = (
    <div className="flex items-center justify-start gap-6 w-full lg:w-auto">
      <Logo />
      {type === "home" && <InfoUsuario />}
    </div>
  );

  // Conteúdo específico para cada tipo de layout
  return (
    <>
      {type === "home" && (
        <header className="bg-red-c1 w-full border-b-[6px] border-b-red-c3">
          <div className="header-content flex items-center justify-between w-full gap-x-4">
            {logoContent}
            <div className='header-control flex items-center justify-between md:flex-column'>
              <div className="self-center m-4 w-full lg:w-auto">
                <Filtros onFiltrarClick={onFiltrarClick} dadosCarregados={dadosCarregados} cargoChange={cargoChange} mesAnoChange={mesAnoChange} />
              </div>

              <div className='flex md:flex-column md:header-controls'>
                {isAdmin && <button onClick={handleAdmin} className="bg-gray-c2 rounded text-white h-10 px-6 mr-4 md:px-0 md:mr-00 md:mt-04">Admin</button>}
                <button onClick={handleLogout} className="bg-gray-c2 rounded text-white h-10 px-6 mr-4 md:px-0 md:mr-00 md:mt-04">Sair</button>
              </div>
            </div>

          </div>
        </header>
      )}

      {type === "painelBordo" && (
        <header className="bg-red-c1 w-full border-b-[6px] border-b-red-c3">
          <div className="flex items-center justify-between w-full flex-wrap relative">
            <div className="pl-6 pr-1 md:pr-2">
              <img src={mmlogo} alt="Logo da MM" className="h-8 object-contain max-w-full" />
            </div>
          </div>
          <div className='header-control flex items-center justify-between md:flex-column'>
            <div className="self-center m-4 w-full lg:w-auto">
              <FiltrosPainelBordo onFiltrarClick={onFiltrarClick} dadosCarregados={dadosCarregados} />
            </div>
          </div>
        </header>
      )}

      {type === "otherPage" && (
        <header className="bg-red-c1 w-full border-b-[6px] border-b-red-c3">
          <div className="flex items-center justify-between w-full flex-wrap relative">
            <div className="pl-6 pr-1 md:pr-2">
              <img src={mmlogo} alt="Logo da MM" className="h-8 object-contain max-w-full" />
            </div>
            <div className="self-center h-full font-poppins font-semibold text-lg text-white">
              <button onClick={voltar} className="flex items-center justify-between gap-1 bg-red-c2 h-full px-4 py-5"><img src={backImagem} alt="Voltar" className="inline-block" />Voltar</button>
            </div>
          </div>
        </header>
      )}
    </>
  );

}

export default Header